var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balance-vs-cashflow-button"},[_c('separator'),_vm._v(" "),_c('div',{staticClass:"explain-balance-vs-balance",on:{"click":_vm.openExplanation}},[_vm._v("\n    איך זה השפיע על העו״ש?\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }